// extracted by mini-css-extract-plugin
export default {"pageSizeDropdown":"pageSizeDropdown_pageSizeDropdown__9UT4Z","dropdown":"pageSizeDropdown_dropdown__CM2GB","sizeList":"pageSizeDropdown_sizeList__3bArl"};